import Api from 'src/services/Api';
import { FEATURE_FLAGS_URL } from 'src/config/urls';
import { FeatureFlagsJSON } from '../types';

export default class FeatureFlagsSystem {
	private api: Api;

	constructor( { api }: { api: Api } ) {
		this.api = api;
	}

	async fetchFeatureFlags(): Promise<FeatureFlagsJSON> {
		const { response } = await ( this.api.get( FEATURE_FLAGS_URL ) as Promise<{ response: FeatureFlagsJSON }> );
		return response;
	}
}
